/* eslint-disable @typescript-eslint/no-explicit-any */
import {ChevronDown} from '@jobseeker/lotus/assets/icons';
import {useTheme} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import SelectElement from '@jobseeker/lotus/elements/Select';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';

const isAppHirist = process.env.NEXT_PUBLIC_APP_NAME === 'hirist';

export const SelectIcon = ({className}: any) => {
  const theme = useTheme();
  return (
    <Image
      className={className}
      src={ChevronDown}
      alt={'Drop Down Arrow'}
      width={12}
      height={12}
      style={{
        userSelect: 'none',
        padding: '2px',
        zIndex: 0,
        marginRight: theme.spacing(1.7),
        marginLeft: theme.spacing(1.7),
        marginTop: theme.spacing(0.4),
        transition: '0.3s ease-in-out',
      }}
      objectFit="cover"
    />
  );
};

const SelectV2 = ({SelectProps, ...props}: any) => (
  <SelectElement
    SelectProps={{style: {fontSize: 12}, ...SelectProps}}
    variant={VersionVariants.VERSION_TWO}
    sx={{
      maxWidth: 390,
      width: '100%',
      height: '40px',
      input: {padding: '14px 16px'},
    }}
    {...props}
    {...(isAppHirist && {hiristColor: true})}
  />
);

export default SelectV2;
